import type { ModuleDefinition } from '../../../app/moduleRegistry';
import { isFeatureEnabled } from '../../../config/featureFlags';
import TitleListPage from './pages/TitleListPage';

export const titleModule: ModuleDefinition = {
  routes: [{ path: 'corporate/title', element: <TitleListPage /> }],
  menuItems: [
    {
      label: 'Kurumsal: Unvanlar',
      path: 'corporate/title',
      isVisible: () => isFeatureEnabled('HasKurumsal'),
    },
  ],
};
